module.exports = __webpack_public_path__ + "img/fig12.0eb7a831.jpg";